export const CDN = 'https://emerich-custom.nyc3.digitaloceanspaces.com'

export const getHouses = () => fetch('/api/houses').then(r => r.json())
export const getHouse = (id) => fetch(`/api/houses/${id}`).then(r => r.json())
